import React from "react";

import "./quote-preview.css";

const QuotePreview = (props) => {
  // No allow-scripts: the email HTML embeds quote/lead text and must never
  // execute in the CRM origin (matches the trip and 2025 quote previews).
  return (
    <iframe
      id="quoteEmailPreview"
      className="outsideOrgPreview"
      sandbox="allow-same-origin"
      srcDoc={props.emailPreview.body}
      title="Quote Preview"
    />
  );
};

export default QuotePreview;
